module.exports = __webpack_public_path__ + "img/governance-bannner4.7140544e.png";